module.exports = __webpack_public_path__ + "img/NukedTV-Web_11.5a207054.png";